import React from 'react';
import { Text, TextTypography } from 'wix-ui-tpa';
import { useTranslation } from 'react-i18next';
var EmptyState = function (_a) {
    var isLiveSite = _a.isLiveSite, locale = _a.locale;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    React.useEffect(function () {
        locale && void i18n.changeLanguage('locale');
    }, [locale]);
    var headerContent = isLiveSite
        ? 'calendar_widget_empty_state_site_title'
        : 'calendar_widget_empty_state_previw_title';
    var textContent = isLiveSite
        ? 'calendar_widget_empty_state_site_subtitle'
        : 'calendar_widget_empty_state_previw_subtitle';
    return (React.createElement("div", { style: {
            border: '1px solid grey',
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '40px',
            textAlign: 'center',
        } },
        React.createElement(Text, { typography: TextTypography.largeTitle }, t(headerContent)),
        React.createElement(Text, null, t(textContent))));
};
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map